module.exports = __webpack_public_path__ + "static/media/EditParLevelsIcon.7ebb0d60.svg";